import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const CartContext = createContext(null);
const STORAGE_KEY = "vitura_cart_id";

export function CartProvider({ children }) {
  const [cart, setCart] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);

  const ensureCart = useCallback(async () => {
    let id = localStorage.getItem(STORAGE_KEY);
    try {
      if (id) {
        const c = await api.getCart(id);
        setCart(c);
      } else {
        const c = await api.createCart();
        localStorage.setItem(STORAGE_KEY, c.id);
        setCart(c);
      }
    } catch (e) {
      // If cart missing, create a new one
      const c = await api.createCart();
      localStorage.setItem(STORAGE_KEY, c.id);
      setCart(c);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { ensureCart(); }, [ensureCart]);

  const addItem = async (payload) => {
    if (!cart) return;
    const updated = await api.addLine(cart.id, payload);
    setCart(updated);
    setOpen(true);
    toast.success("Added to cart");
  };

  const updateItem = async (variantId, quantity) => {
    if (!cart) return;
    const updated = await api.updateLine(cart.id, { variant_id: variantId, quantity });
    setCart(updated);
  };

  const removeItem = async (variantId) => {
    if (!cart) return;
    const updated = await api.removeLine(cart.id, variantId);
    setCart(updated);
  };

  const checkout = async () => {
    if (!cart) return null;
    const res = await api.checkout(cart.id);
    return res;
  };

  return (
    <CartContext.Provider value={{ cart, loading, open, setOpen, addItem, updateItem, removeItem, checkout, refresh: ensureCart }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
